import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';
import { getSMSizes } from "../ranking-sm/data";

const columns = {
    city: "City",
    budget: "Budget",
    budgetPerCitizen: "Budget per<br>resident",
    guards: "Number of<br>guards",
    guardsPer100k: "Guards per<br>100k residents",
}

/**
 * @param {string} id
 */
export default function gridBudget(id) {
    if (!document.getElementById(id)) return;

    const smData = getSMSizes()

    Grid.grid(id, {
        dataTable: {
            columns: {
                [columns.city]: smData.map(e => e.city),
                [columns.budget]: smData.map(e => e["Budżet"]),
                [columns.budgetPerCitizen]: smData.map(e => e.budgetPerCitizen),
                [columns.guards]: smData.map(e => e["Etaty: liczba strażników"]),
                [columns.guardsPer100k]: smData.map(e => e.guardsPer100k),
            }
        },
        rendering: {
            rows: { strictHeights: false },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [{
            id: "City",
            cells: { className: 'bold' }
        }, {
            id: columns.budget,
            cells: { format: '{(divide value 1000000):.1f} mln PLN' }
        }, {
            id: "Budget per<br>resident",
            cells: { format: '{(value):.0f} PLN' }
        }, {
            id: "Number of<br>guards",
            cells: { format: '{(value):.0f}' }
        }, {
            id: "Guards per<br>100k residents",
            cells: { format: '{(value):.1f}' }
        }]
    });
}
